import { Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { BasketViewComponent } from './basket-view.component';
export namespace NBasketViewCms {
    export const BLOCK_ID = 'cms-basket-view';
    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;
    export interface IBlockDataContent {
        showEuRegulationsMessage?: boolean;
        bgColorTextBlocks?: string;
        euRegulationsMessage?: string;
        basketStockMessaging?: string;
        basketMessage?: string;
        /**
         * Right hand side image
         */
        sideImage?: string;
        sideImageRatio?: string;
        /**
         * Right hand side copy
         */
        sideCopy?: string;
        /**
         * Bottom components list
         */
        bottomComponents?: NICmsContentComponent.IData[];
        emptyComponents: NICmsContentComponent.IData[];
        payment_method_icons: IPaymentMethodIcon[];
    }
    export interface IPaymentMethodIcon {
        payment_method_icon?: 'mc' | 'amex' | 'visa' | 'maestro' | 'paypal' | 'apple' | 'googlepay' | 'v12';
    }

    export const paymentMethodIconsIcmsField = <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'payment_method_icons',
        title: 'Payment Method icons',
        itemName: 'payment method',
        fields: [
            <NICmsContentField.IChoiceField>{
                type: NICmsContentField.EFieldType.choice,
                key: 'payment_method_icon',
                title: 'Payment service',
                options: [
                    { key: 'mc', title: 'Master Card' },
                    { key: 'amex', title: 'Amex' },
                    { key: 'visa', title: 'Visa' },
                    { key: 'maestro', title: 'Maestro' },
                    { key: 'paypal', title: 'Paypal' },
                    { key: 'apple', title: 'ApplePay' },
                    { key: 'googlepay', title: 'GooglePay' },
                    { key: 'v12', title: 'V12' }
                ]
            }
        ]
    };
}
/**
 * Component definition
 */
@Component({
    selector: 'cms-basket-view-cms',
    template: '<basket-view [content]="content"></basket-view>',
    standalone: true,
    imports: [BasketViewComponent]
})
@ICmsComponent<BasketViewCmsComponent>({
    id: NBasketViewCms.BLOCK_ID,
    block: {
        url: NBasketViewCms.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Basket page layout',
    description: 'Basket page layout block',
    fields: [
        {
            key: 'showEuRegulationsMessage',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show EU Regulations Message'
        },
        <NICmsContentField.IColorPickerField>{
            key: 'bgColorTextBlocks',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Background Color Text Blocks'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'euRegulationsMessage',
            title: 'EU Regulations Message'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'basketStockMessaging',
            title: 'Basket Stock Messaging'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'basketMessage',
            title: 'Basket View Message'
        },
        NBasketViewCms.paymentMethodIconsIcmsField,
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-specification',
            title: 'Side area'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'sideImage',
            title: 'Side image'
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'sideImageRatio',
            title: 'Side image ratio',
            options: RatioOptions
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'sideCopy',
            title: 'Side copy'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-bottom',
            title: 'Bottom part'
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-empty',
            title: 'Empty basket'
        },
        <NICmsContentField.IComponentsField>{
            key: 'emptyComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Empty basket components',
            itemName: 'component',
            default: []
        }
    ]
})
export class BasketViewCmsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NBasketViewCms.IBlockDataContent;
    protected override canDetach = false;
}
